
interface StopIconProps {
    className?: string;
}


export function StopIcon({ className }: StopIconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24">
            <path d="M6 6h12v12H6z" />
        </svg>
    );
}
